import React from "react";
import { PremiumProspectusCoursePage } from "./CoursePageDesignsCore";
import MetaInfo from "./components/MetaInfo";
import Header from "./components/Header";
import Footer from "./components/Footer";

export default function CourseDetails5(props) {
    return (
        <>
            <MetaInfo />
            <Header school="common" />
            <PremiumProspectusCoursePage {...props} />;
            <Footer />
        </>
    )
};
